import { __decorate } from "tslib";
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ProductListing from '@/components/v3/inbox_manager/ProductListing.vue';
let InviteSubscriberPreview = class InviteSubscriberPreview extends Mixins(ViewportSizeMixin, RouterParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.shouldScrollToBottom = false;
        this.ecommerceProducts = [
            {
                price: 10.0,
                name: 'Super Deal',
                featuredGalleryPhoto: {
                    galleryBlob: {
                        originalUrl: 'https://placehold.co/300x200/007a5a/FFF?text=SUPER+DEAL',
                    },
                },
            },
            {
                price: 10.0,
                name: 'Super Deal',
                featuredGalleryPhoto: {
                    galleryBlob: {
                        originalUrl: 'https://placehold.co/300x200/007a5a/FFF?text=SUPER+DEAL',
                    },
                },
            },
            {
                price: 10.0,
                name: 'Super Deal',
                featuredGalleryPhoto: {
                    galleryBlob: {
                        originalUrl: 'https://placehold.co/300x200/007a5a/FFF?text=SUPER+DEAL',
                    },
                },
            },
        ];
    }
    onIsProvideOfferOptionsChange() {
        if (!this.isProvideOfferOptions) {
            this.scrollToBottom();
        }
    }
    // private get selectedImage() {
    //   const file = this.image[0]?.file;
    //   if (file) {
    //     return file?.dataURL || '';
    //   }
    //   const image = this.image[0];
    //   return image?.url || '';
    // }
    get selectedImage() {
        if (Array.isArray(this.image)) {
            const filteredImages = this.image.filter((img) => img.state === 'idle' || img.state === 'new');
            const filteredImagesLength = filteredImages?.length;
            return (filteredImages[filteredImagesLength - 1]?.url ||
                filteredImages[filteredImagesLength - 1]?.file.dataURL ||
                '');
        }
        return this.image?.file?.photoUrl || '';
    }
    scrollToBottom() {
        this.$nextTick(() => {
            const container = this.$refs.inviteSubscriber;
            if (!container) {
                return;
            }
            container.scrollTop = container.scrollHeight;
        });
    }
};
__decorate([
    Prop({ type: Array, required: true })
], InviteSubscriberPreview.prototype, "image", void 0);
__decorate([
    Prop({ type: String, required: true })
], InviteSubscriberPreview.prototype, "title", void 0);
__decorate([
    Prop({ type: String, required: true })
], InviteSubscriberPreview.prototype, "greeting", void 0);
__decorate([
    Prop({ type: String, required: true })
], InviteSubscriberPreview.prototype, "payload", void 0);
__decorate([
    Prop({ type: String, required: true })
], InviteSubscriberPreview.prototype, "buttonCaption", void 0);
__decorate([
    Prop({ type: Boolean, required: true })
], InviteSubscriberPreview.prototype, "isProvideOfferOptions", void 0);
__decorate([
    Prop({ type: Array, required: true })
], InviteSubscriberPreview.prototype, "products", void 0);
__decorate([
    Watch('isProvideOfferOptions')
], InviteSubscriberPreview.prototype, "onIsProvideOfferOptionsChange", null);
InviteSubscriberPreview = __decorate([
    Component({
        name: 'InviteSubscriberPreview',
        components: { ProductListing },
    })
], InviteSubscriberPreview);
export default InviteSubscriberPreview;
